import React from 'react';
import { boardSearchAreas } from '../../data/approach';
import { Reveal } from '../motion/Reveal';
type SearchAreasListProps = {
  onDark?: boolean;
};
export function SearchAreasList({
  onDark = false
}: SearchAreasListProps) {
  return <ul className={`border-b ${onDark ? 'border-white/15' : 'border-line'}`} data-id="element-353" data-mp="211vy0pp4pqwp">
      {boardSearchAreas.map((area, index) => <Reveal as="li" key={area.title} delay={Math.min(index, 4) * 50} className={`grid gap-2 border-t py-7 sm:grid-cols-[minmax(0,2fr)_minmax(0,3fr)] sm:gap-8 ${onDark ? 'border-white/15' : 'border-line'}`} data-id="element-354" data-mp="1r3yak4f3fy55" data-mpi={index}>
          <h3 className={`font-serif text-[1.45rem] font-medium leading-snug ${onDark ? 'text-white' : 'text-navy'}`} data-id="element-355" data-mp="1i5cy8r07tfct">
            {area.title}
          </h3>
          <p className={`text-[15px] leading-relaxed ${onDark ? 'text-white/70' : 'text-muted'}`} data-id="element-356" data-mp="3ciciixfjixqf">{area.description}</p>
        </Reveal>)}
    </ul>;
}